import { SET_INIT_APP_INFO } from '../constants/acitonTypes';

// 默认值是开发环境下提供的
export default function initApp(
  state = {
    userInfo: {}
  },
  action
) {
  switch (action.type) {
    case SET_INIT_APP_INFO:
      return { ...state, ...action.value };
    default:
      return state;
  }
}
